import itemFlagActions from '../actions/ItemFlagActions';
import utilService from '../services/UtilService';

export function addOrRemoveFromListOfFlaggedItems(contentRevisionId, setAsFlagged, currentlyFlaggedItems) {
    const currentIndex = currentlyFlaggedItems.indexOf(`${contentRevisionId}`);
    const flaggedItems = [...currentlyFlaggedItems];

    if (setAsFlagged && currentIndex === -1) {
        flaggedItems.push(contentRevisionId);
    } else if (!setAsFlagged && currentIndex > -1) {
        utilService.removeFromArray(currentIndex, flaggedItems);
    }

    return flaggedItems;
}

const defaultState = {
    flaggedItems: [],
    focusedItem: null,
};

export default function responseReducer(state = defaultState, action) {
    switch (action.type) {
    case itemFlagActions.types.FLAGGED_ITEMS_TOGGLE:
        return Object.assign({}, state, {
            flaggedItems: addOrRemoveFromListOfFlaggedItems(action.identifier, action.setAsFlagged, state.flaggedItems),
        });

    case itemFlagActions.types.FLAGGED_ITEMS_SET:
        return Object.assign({}, state, {
            flaggedItems: action.flaggedItems,
        });

    case itemFlagActions.types.FLAGGED_ITEMS_FOCUS:
        return Object.assign({}, state, {
            focusedItem: action.identifier,
        });

    default:
        return state;
    }
}
